import React from 'react';
import { MicroFrontend } from 'micro-frontend';
import { Divider } from '@material-ui/core';

interface VendorDetailsProps {
  transactionId: string;
}

export const VendorDetails = ({ transactionId }: VendorDetailsProps) => {
  return (
    <>
      <Divider />
      <MicroFrontend name="VendorDetails" data={{ transactionId }} height="fill" />
      <Divider />
    </>
  );
};
